import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import { useGameStore } from './store/gameStore'
import { useAuthStore } from './store/authStore'

// Pages
import LandingPage from './pages/LandingPage'
import MultiGarden from './pages/MultiGarden'
import Shop from './pages/Shop'
import Merchant from './pages/Merchant'
import Community from './pages/Community'
import MyPublishedPlants from './pages/MyPublishedPlants'
import PlayerGarden from './pages/PlayerGarden'
import Account from './pages/Account'
import Auth from './pages/Auth'
import Help from './pages/Help'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import Profile from './pages/Profile'

// Components
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'

function App() {
  const loadGameConfig = useGameStore((state) => state.loadGameConfig)
  const initAuth = useAuthStore((state) => state.initAuth)

  useEffect(() => {
    // Initialize authentication
    initAuth()
    
    // Load game configuration
    loadGameConfig()
  }, [loadGameConfig, initAuth])

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<LandingPage />} />
          <Route path="auth" element={<Auth />} />
          <Route path="help" element={<Help />} />
          <Route path="terms" element={<Terms />} />
          <Route path="privacy" element={<Privacy />} />
          
          {/* Routes accessibles sans connexion */}
          <Route path="garden" element={<MultiGarden />} />
          <Route path="shop" element={<Shop />} />
          <Route path="shop/:merchantType" element={<Merchant />} />
          
          {/* Routes nécessitant une connexion */}
          <Route path="community" element={<ProtectedRoute><Community /></ProtectedRoute>} />
          <Route path="my-plants" element={<ProtectedRoute><MyPublishedPlants /></ProtectedRoute>} />
          <Route path="player/:playerId" element={<ProtectedRoute><PlayerGarden /></ProtectedRoute>} />
          <Route path="account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
          <Route path="profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        </Route>
      </Routes>
    </Router>
  )
}

export default App
